<template>
  <ubi-page-container wide-main-content>
    <ubi-panel>

      <el-row>
        <div style="font-size: 120%;">
          <p class="text-justify" v-html="$t('contact.mainText')"/>
        </div>
        <br><br>
      </el-row>
      <el-form :model="form" :rules="rules" ref="contactForm">
        <el-row>
          <el-form-item :label="$t('contact.object')" prop="object">
            <el-select
                    v-model="form.object"
                    clearable
            >
              <el-option
                      v-for="tmpObject in objects"
                      :key="tmpObject.label"
                      :label="tmpObject.label"
                      :value="tmpObject.label"
              />
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('contact.writeMessage')" prop="message">
            <el-input
                    :autosize=true
                    rows="8"
                    type="textarea"
                    v-model="form.message"
                    :placeholder="$t('contact.writeMessagePlaceholder')"
            />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('contact.name')" prop="name">
            <el-input v-model="form.name"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('contact.email')" prop="email">
            <el-input v-model="form.email"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('contact.phone')" prop="phone">
            <el-input v-model="form.phone" type="tel"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="sendCopy">
              <el-checkbox v-model="form.sendCopy">
                {{ $t("contact.sendEmailCopy") }} {{form.email}}
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <br><br>
          <div class="text-center">
            <el-button type="primary" @click="send">{{ $t("contact.send") }}</el-button>
          </div>
        </el-row>
      </el-form>

    </ubi-panel>
  </ubi-page-container>
</template>

<script>

import { sendEmail } from '@/services/email'
import { mapGetters } from 'vuex'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'NousContacter',
  components: { UbiPanel, UbiPageContainer },
  data () {
    return {
      form: {
        object: null,
        message: null,
        name: null,
        email: null,
        phone: null,
        sendCopy: false
      },
      objects: [],
      rules: {
        object: [{ required: true, message: this.$t('contact.ruleObjectRequired'), trigger: 'blur' }],
        message: [{ required: true, message: this.$t('contact.ruleMessageRequired'), trigger: 'blur' }],
        email: [{ required: true, message: this.$t('contact.ruleEmailRequired'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['getSitimmoUser', 'getUser'])
  },
  mounted () {
    this.chargerObjetContact()
    this.form.email = this.getUser.email
    this.form.phone = this.getUser.phone ? this.getUser.phone : ''
    this.form.name = [this.getUser.firstname, this.getUser.lastname].join('')
  },
  methods: {
    async send () {
      this.$ga.event('formulaire', 'clic', 'envoyer_demande', this.getSitimmoUser.id)
      this.loading = true

      this.$refs.contactForm.validate(async (valid) => {
        if (valid) {
          let sendTo = ''
          const mailMatched = this.objects.filter(obj => {
            return obj.label === this.form.object
          }, this)

          if (this.getSitimmoUser.estAnnonceurUtilisateur === true) {
            sendTo = sendTo + processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_RC
          } else {
            sendTo = sendTo + mailMatched[0].value
          }

          if (this.form.sendCopy) {
            sendTo = sendTo + ',' + this.form.email
          }
          const mailData = {
            to: sendTo,
            replyTo: this.form.email,
            subject: '[CONTACT-ESPACE-CLIENT] ' + '[' + this.getUser.username + '] ' + this.form.object,
            email_content: this.form.message,
            contact_name: this.form.name,
            contact_email: this.form.email,
            contact_phone: this.form.phone
          }
          const response = await sendEmail(mailData)
          if (response.type == 'error') {
            this.$message({ message: this.$t('error.found'), type: 'error' })
            this.loading = false
            return false
          }
          window.alert(response.message)
          this.loading = false
          this.$router.push({
            name: 'dashboard'
          }
          )
        } else {
          return false
        }
      })
    },
    chargerObjetContact () {
      this.objects = [
        {
          label: this.$t('contact.objectOption1'),
          value: processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
        },
        { label: this.$t('contact.objectOption6'), value: processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_RC },
        { label: this.$t('contact.objectOption5'), value: processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_RC }
      ]
    }
  }
}
</script>
